import { useEffect, useState } from 'react';
import axios from 'axios';
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { ccColorDarkTeal } from './helpersStyles';
import { InputText } from '../commonComponents/inputFields';
import { CcActionButton, CcActionButtonOutlined, CcCreateNewButton } from '../commonComponents/styledTexts';
import { CcLoader } from '../commonComponents/generalComponents';
import { RandomId } from './helpers';
import { lionIcons } from './helpersIcons';
import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, dataFunctionsValidationSchema } from '../components/helperErrors'


const FunctionCodeToolTip = (props) => {

    return (
        <Tooltip placement='top'
          title={<div className='text-ccColorDarkTeal font-poppins text-base'>
                    <div className='text-lg font-semibold'>Function Code</div>
                    <div>Write code in Javascript</div>
                    <div className='mt-2'>Write only the logic of the function, you don't need to declare a function using <span className='font-sourceCodePro'>function</span> or <span className='font-sourceCodePro'>const</span> keywords</div>
                    <div className='flex flex-col bg-red-50 w-[400px] py-1 px-2 rounded'>
                        <div className='text-red-600'>NO</div>
                        <div className='font-sourceCodePro'>function Sum(num1, num2) {"{"}<br/>
                            return num1 + num2;<br/>
                            {"}"}
                        </div>
                    </div>
                    <div className='flex flex-col bg-green-50 w-[400px] mt-4 py-1 px-2 rounded'>
                        <div className='text-green-600'>YES</div>
                        <div className='font-sourceCodePro'>
                            return num1 + num2;
                        </div>
                    </div>
                    <div className='mt-2'>Make sure the function returns a value</div>
                    <div className='mt-2'>You can create input parameters <span className='font-sourceCodePro'>(e.g. num1, num2)</span> in the Parameters section.</div>
                </div>}
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  //offset: [0, 8],
                },
              },
            ],
          }}
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: 740, // Set custom width
                width: 740, // Set custom width
                whiteSpace: 'normal', // Allow wrapping
                backgroundColor: '#fff',     // White background
                color: '#000',               // Black text
                boxShadow: 3,                // Optional shadow
                border: '1px solid #ddd',    // Optional border                
              },
            },
          }}
        >
            <Iconify icon="material-symbols:info-outline" width={28} color={ccColorDarkTeal} />
        </Tooltip>
      );
}


const DataFunctionCard = (props) => {

    //useEffect(() => {console.log(props.function)},[])

    const handleCardClick = () => {
        if (props.onClick) props.onClick(props.function.functionName)
    }

    return <div className={`border rounded p-1 text-ccColorDarkTeal font-poppins ${props.selected ? 'bg-zinc-200' : 'hover:bg-slate-200 hover:cursor-pointer'}`}
                onClick={handleCardClick}>
        <div className='flex flex-row'>
            <div className='font-semibold text-lg'>{props.function.functionPrettyName}</div>
            <div className='flex grow'></div>
            <div className={`${props.function.origin === 'CodeChemistry' ? 'bg-ccColorOrange': 'bg-ccColorTeal'} rounded p-1 text-white text-sm font-semibold`}>{props.function.origin}</div>
        </div>
        <div className='text-sm text-gray-600'>{props.function.description}</div>

        <div className='flex flex-row mt-2 gap-x-2'>
            <div className='font-semibold'>Inputs</div>
            <div>
                {props.function.metadata.parameters.map(p =><div className='mb-2'>
                    <div className='font-sourceCodePro text-lg font-semibold'>{p.name}</div>    
                    <div className='text-sm'>{p.description}</div>    
                </div>)}
            </div>
        </div>

    </div>
} 

export const DataFunctionsViewer = (props) => {
  
    const [functions, setFunctions] = useState([]);
    const [selectedFunctionName, setSelectedFunctionName] = useState('');
    const [selectedFunction, setSelectedFunction] = useState({});
    const [updatingFunction, setUpdatingFunction] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [activeErrorList, setActiveErrorList] = useState([]);

    useEffect(() => {
        getFunctions()
    }, [])
  
    const getFunctions = async () => {
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/DataFunctions`;
            const response = await axios.get(url);
            const data = response.data;
            setFunctions(data)


        } catch (error) {
            console.log(error);
        }
    }
    const handleFunctionClicked = (fName) => {
        setSelectedFunctionName(fName)
        const selectedFunc = functions.find(f => f.functionName === fName)
        setSelectedFunction(selectedFunc)
    }
    const handleSelectedFunctionChange = (propName, propValue) => {
        const newFunction = {...selectedFunction, [propName]: propValue}
        //console.log(newFunction)
        setSelectedFunction(newFunction)
        setErrorMsg('')

        if (activeErrorList.length > 0) {
            try {
                //console.log(snippetData)
                dataFunctionsValidationSchema.validateSync(newFunction, {abortEarly: false});
                setActiveErrorList([])
            }
            catch (e) {
                //console.log(JSON.parse(JSON.stringify(e)))
                const errorList = getErrorListFromYupError(e)
                setActiveErrorList(errorList)
                return false;
            }
        }

    }
    const handleSelectedFunctionParameterChange = (index, propName, propValue) => {
        const newParameters = [...selectedFunction.metadata.parameters]
        const newParam = {...newParameters[index], [propName]: propValue}

        newParameters.splice(index,1,newParam)
        const newMetadata = {...selectedFunction.metadata, parameters: newParameters}

        handleSelectedFunctionChange('metadata', newMetadata)
    }
    const handleSelectedFunctionAddParameter = () => {
        const newParameters = [...selectedFunction.metadata.parameters]
        
        newParameters.push({name: '', description: ''})
        const newMetadata = {...selectedFunction.metadata, parameters: newParameters}

        handleSelectedFunctionChange('metadata', newMetadata)
    }
    const handleSelectedFunctionDeleteParameter = (index) => {
        const newParameters = [...selectedFunction.metadata.parameters]

        newParameters.splice(index,1)
        const newMetadata = {...selectedFunction.metadata, parameters: newParameters}

        handleSelectedFunctionChange('metadata', newMetadata)
    }

    const handleUpdateFunction = async () => {
      try {
        //console.log(snippetData)
        dataFunctionsValidationSchema.validateSync(selectedFunction, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return false;
      }


        try {  
            setErrorMsg('')
            setUpdatingFunction(true)
            const url = `${process.env.REACT_APP_LION_API_URL}/DataFunctions/update`;
            const response = await axios.post(url, selectedFunction);
            const data = response.data;
            setErrorMsg(data)
            

        } catch (error) {
            console.log(error);
        }
        finally {setUpdatingFunction(false)}

    }
    const handleCreateNewFunction = () => {
        const newFunction = {functionName: RandomId(24), functionPrettyName: "myFunction", description: "example function to sum two numbers: num1 and num2",
                                functionCode: `//delete this code and write your own
                                            return num1 + num2`,
                                origin: "User Defined",
                                metadata: {parameters: [{name: "num1", description: "first number to sum"},{name: "num2", description: "second number to sum"}]}
                            }
        const newFunctions = [...functions, newFunction]
        setFunctions(newFunctions)
        setSelectedFunction(newFunction)
        setSelectedFunctionName(newFunction.functionName)

        //console.log(functions)
    }

    return <div className='grid grid-cols-2 gap-x-4'>
        <div>
            <div className='flex flex-col gap-y-1 max-h-[660px] overflow-y-auto'>
                {functions.map(f => <DataFunctionCard function={f}
                                        selected={f.functionName === selectedFunctionName}
                                        onClick={handleFunctionClicked}
                                        />)
                }
            </div>
            <div className='mt-2'>
                <CcCreateNewButton onClick={handleCreateNewFunction}>Add new function</CcCreateNewButton>
            </div>
        </div>
        <div className='border rounded py-1 px-2 text-ccColorDarkTeal font-poppins'>
            {selectedFunction.origin === 'CodeChemistry' && <div className='mt-8 text-center'>
                This function is not editable
            </div>

            }
            {selectedFunction.origin && selectedFunction.origin !== 'CodeChemistry' && <>
            <div className="flex flex-row gap-x-4">
                <InputText
                        displayName="Name"
                        value={selectedFunction.functionPrettyName}
                        onChange={(val) => {handleSelectedFunctionChange('functionPrettyName', val);}}
                        error={getErrorMessage(activeErrorList, 'functionPrettyName')}
                />
                <InputText
                        displayName="Description"
                        value={selectedFunction.description}
                        onChange={(val) => {handleSelectedFunctionChange('description', val);}}
                        error={getErrorMessage(activeErrorList, 'description')}
                />
            </div>
            <div className='mt-4 text-lg font-semibold'>Parameters</div>
            {selectedFunction.metadata.parameters.map((p, index) => <div className="flex flex-row gap-x-4 mb-2">
                <InputText
                        displayName="Name"
                        value={p.name}
                        onChange={(val) => {handleSelectedFunctionParameterChange(index, 'name', val);}}
                        error={getErrorMessageForArray(activeErrorList, 'functionParameters', index)}
                />
                <InputText
                        displayName="Description"
                        value={p.description}
                        onChange={(val) => {handleSelectedFunctionParameterChange(index, 'description', val);}}
                        //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                />
                <div className='mt-[22px]'>
                    <div className='rounded-full p-1 hover:bg-slate-100 hover:cursor-pointer'
                        onClick={() => handleSelectedFunctionDeleteParameter(index)}><Iconify icon={lionIcons.Icon_Actions_Delete} width={28}/></div>
                </div>
                
            </div>)
            }
            <CcActionButtonOutlined onClick={handleSelectedFunctionAddParameter}>Add parameter</CcActionButtonOutlined>
            
            <div className='mt-4 flex flex-row gap-x-4'>
                <div className='text-lg font-semibold'>Code</div>
                <FunctionCodeToolTip />

            </div>
            <textarea class="block h-[300px] p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border-2 border-gray-300 outline-none focus:border-ccColorDarkTeal" placeholder="Write your code here..."
                    onChange={(e) => {handleSelectedFunctionChange('functionCode', e.target.value);}}
                    value={selectedFunction.functionCode}
                    ></textarea>
            <div className='mt-2 flex flex-row'>
                <div className='flex grow justify-center items-center'>
                    {errorMsg === 'Ok' && <div className='w-3/4 py-1 text-center bg-green-200 rounded text-green-700 font-semibold'>
                    Code compiled</div>}
                    {errorMsg.length > 0 && errorMsg !== 'Ok' && <div className='w-3/4 py-1 text-center bg-red-200 rounded text-red-700'>
                    Error, code can't compile</div>}
                </div>
                <CcActionButton onClick={handleUpdateFunction}>
                    {updatingFunction ? <CcLoader size={16} /> : <>Update</>}
                </CcActionButton>
                
            </div>
            </>
            }
            {selectedFunction.origin === undefined && <div className='mt-8 text-center'>
                No Function Selected
            </div>

            }
        </div>
        
    </div>
}